import { render } from "./OrderReturn.vue?vue&type=template&id=48255675"
import script from "./OrderReturn.vue?vue&type=script&lang=js"
export * from "./OrderReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__